import React from 'react';
import { Container, Row, Col, Card, Table, Badge } from 'react-bootstrap';

const ListaAsociadosInhabiles: React.FC = () => {
  const cooperativaInfo = {
    nombre: "Cooperativa Multiactiva del Magdalena y del Caribe",
    nit: "901558424-3",
    sigla: "COOPMULMAG"
  };

  // Datos de ejemplo - Estos deberían venir de tu backend o API
  const asociadosInhabiles = [
    { id: 1, nombre: "Carlos Alberto Rodríguez Martínez", documento: "CC 12.345.678", motivo: "Morosidad en aportes (3 meses)", estado: "Inhábil" },
    { id: 2, nombre: "María Fernanda López Pérez", documento: "CC 23.456.789", motivo: "Incumplimiento de obligaciones crediticias", estado: "Inhábil" },
    { id: 3, nombre: "Juan David González Castro", documento: "CC 34.567.890", motivo: "Aportes pendientes y documentación incompleta", estado: "Inhábil" },
    { id: 4, nombre: "Ana Milena Sánchez Rojas", documento: "CC 45.678.901", motivo: "Morosidad en aportes (2 meses)", estado: "Inhábil" },
    { id: 5, nombre: "Pedro Antonio Jiménez Vargas", documento: "CC 56.789.012", motivo: "Incumplimiento de obligaciones estatutarias", estado: "Inhábil" },
    { id: 6, nombre: "Luz Dary Ramírez Gómez", documento: "CC 67.890.123", motivo: "Morosidad en aportes (4 meses)", estado: "Inhábil" },
    { id: 7, nombre: "Jorge Enrique Medina Torres", documento: "CC 78.901.234", motivo: "Documentación desactualizada", estado: "Inhábil" },
    { id: 8, nombre: "Sandra Patricia Ríos Moreno", documento: "CC 89.012.345", motivo: "Aportes pendientes", estado: "Inhábil" },
  ];

  

  return (
    <div className="lista-inhabiles py-5">
      <Container>
        {/* Encabezado */}
        <Row className="mb-5">
          <Col className="text-center">
            <h1 className="display-5 fw-bold text-success mb-3">
              Lista de Asociados Inhábiles
            </h1>
            <div className="d-flex justify-content-center gap-3 text-muted">
              <span>{cooperativaInfo.nombre}</span>
              <span>NIT: {cooperativaInfo.nit}</span>
            </div>
          </Col>
        </Row>

        {/* Banner de fecha importante */}
        <Card className="shadow-sm mb-4 border-warning">
          <Card.Body className="bg-warning bg-opacity-10">
            <Row className="align-items-center">
              <Col xs={12} md={8}>
                <div className="d-flex align-items-center">
                  <span className="text-warning me-3 fw-bold fs-3">⚠️</span>
                  <div>
                    <h5 className="fw-bold text-warning mb-1">Publicación: 26 de enero de 2026</h5>
                    <p className="mb-0">Asamblea General Ordinaria de Asociados: <strong>2 de febrero de 2026</strong></p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4} className="text-md-end mt-3 mt-md-0">
                <Badge bg="danger" className="p-2 px-3">Plazo límite: 1 de febrero de 2026</Badge>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Introducción */}
        <Card className="shadow-sm mb-4 border-success">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3 fs-3">
              Comunicado Oficial
            </Card.Title>
            <Card.Text className="fs-5 text-muted">
              En cumplimiento de lo dispuesto en los Estatutos de la Cooperativa y la normatividad vigente, 
              el Consejo de Administración informa a la comunidad cooperativa que, con fecha <strong>26 de enero de 2026</strong>, 
              se publica la presente lista de asociados inhábiles para ejercer su derecho de voto en la 
              Asamblea General Ordinaria de Asociados programada para el día <strong>2 de febrero de 2026</strong>.
            </Card.Text>
            <Card.Text className="fs-5 text-muted mt-3">
              La inhabilidad obedece al incumplimiento de las obligaciones estatutarias y reglamentarias, 
              conforme al régimen de derechos y deberes de los asociados.
            </Card.Text>
          </Card.Body>
        </Card>

        {/* Tabla de asociados inhábiles */}
        <Card className="shadow-sm mb-4 d-none">
          <Card.Header className="bg-success text-white py-3 d-flex justify-content-between align-items-center">
            <h3 className="h4 mb-0 fw-bold">Relación de Asociados Inhábiles</h3>
            <div>
              <Badge bg="light" text="dark" className="me-2 p-2">
                Total: {asociadosInhabiles.length} asociados
              </Badge>
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            <div className="table-responsive">
              <Table hover className="mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Nombre Completo</th>
                    <th>Documento</th>
                    <th>Motivo de Inhabilidad</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {asociadosInhabiles.map((asociado, index) => (
                    <tr key={asociado.id}>
                      <td>{index + 1}</td>
                      <td className="fw-medium">{asociado.nombre}</td>
                      <td>{asociado.documento}</td>
                      <td>{asociado.motivo}</td>
                      <td>
                        <Badge bg="danger" pill>{asociado.estado}</Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
          <Card.Footer className="bg-light p-3">
            <small className="text-muted">
              * Esta lista es de carácter informativo y cumple con los requisitos de transparencia establecidos en los estatutos.
            </small>
          </Card.Footer>
        </Card>

        {/* Nota aclaratoria */}
        <Card className="shadow-sm mb-4 border-info">
          <Card.Body className="bg-info bg-opacity-10">
            <h5 className="fw-bold text-info mb-3">
              <span className="me-2">📌</span>
              Nota Aclaratoria
            </h5>
            <Card.Text className="fs-5">
              Los asociados que figuren en esta lista podrán recuperar su calidad de hábiles si se ponen a paz y salvo 
              con la Cooperativa <strong>antes de la fecha de realización de la Asamblea General (2 de febrero de 2026)</strong>, 
              cumpliendo con las obligaciones estatutarias correspondientes.
            </Card.Text>
            <div className="mt-3 p-3 bg-white rounded-3">
              <p className="mb-0 fw-bold">Para regularizar su situación, los asociados pueden:</p>
              <ul className="mb-0 mt-2">
                <li>Acercarse a la oficina principal de COOPMULMAG</li>
                <li>Realizar el pago de aportes pendientes en los puntos autorizados</li>
                <li>Contactar al departamento de cartera para acordar un plan de pagos</li>
                <li>Actualizar su documentación en caso de estar desactualizada</li>
              </ul>
            </div>
          </Card.Body>
        </Card>

      

        {/* Aviso de privacidad */}
        <Row className="mt-3">
          <Col>
            <Card className="shadow-sm bg-light border-0">
              <Card.Body className="text-center">
                <small className="text-muted">
                  Esta información es de carácter institucional y su uso está restringido a los fines 
                  estatutarios de {cooperativaInfo.sigla}. La publicación se realiza en cumplimiento del 
                  principio de transparencia y derecho a la información de los asociados.
                </small>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Fecha de actualización */}
        <Row className="mt-4">
          <Col className="text-center">
            <p className="fst-italic text-muted">
              Listado generado el: {new Date().toLocaleDateString('es-CO', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ListaAsociadosInhabiles;